<template>
  <Modal v-model="model" title="拨号界面" sticky reset-drag-position  @on-cancel="cancel" :class="{'dialer_hide':!showBtn}"  footer-hide :mask="false" draggable class="dialer_page" :width="width"  id="draggable">
    <div class="dialer_input" :title="docTitle">
      <div class="font_style_set">电话号码:</div>
      <Input v-model="callPhone" placeholder="请输入电话号码" clearable/>
      <div class="phone_note" v-show="!showBtn" @click="call()">
        <img src="../../assets/image/phone.png"/>
      </div>
      <i class="el-icon-arrow-down" v-show="!showBtn" @click="showHandle('0')"></i>
    </div>
    <div class="dialer_btn" v-show="showBtn">
      <Button @click="callNumber('1')">1</Button>
      <Button @click="callNumber('2')">2</Button>
      <Button @click="callNumber('3')">3</Button>
    </div>
    <div class="dialer_btn" v-show="showBtn">
      <Button @click="callNumber('4')">4</Button>
      <Button @click="callNumber('5')">5</Button>
      <Button @click="callNumber('6')">6</Button>
    </div>
    <div class="dialer_btn" v-show="showBtn">
      <Button @click="callNumber('7')">7</Button>
      <Button @click="callNumber('8')">8</Button>
      <Button @click="callNumber('9')">9</Button>
    </div>
    <div class="dialer_btn" v-show="showBtn">
      <Button @click="callNumber('*')" style="line-height: 45px;">*</Button>
      <Button @click="callNumber('0')">0</Button>
      <Button @click="callNumber('#')">#</Button>
    </div>
    <div class="dialer_btn" v-show="showBtn">
      <Button @click="showHandle('1')"><i class="el-icon-arrow-up"></i></Button>
      <Button @click="deleteHandle()"><i class="el-icon-back"></i></Button>
      <Button type="primary" class="phone_btn" @click="call()">拨号</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "DialerPage",
    props: {
      showDialer:Boolean
    },
    data(){
      return {
        model:false,
        callPhone:'',
        showBtn:true,
        draggableSign:false,
        docTitle:"",
        width:'360',
        initX:'',
        initY:'',
        disX:'',
        disY:'',
        left:'',
        top:''
      }
    },
    methods:{
      showHandle:function(sign){
        if(sign=='0'){
          this.showBtn=true;
          this.width="360";
          this.docTitle="";
        }
        if(sign=='1'){
          this.showBtn=false;
          this.width="420";
          this.docTitle="鼠标放到右侧可拖动";
        }
      },
      deleteHandle:function(){
        if(!this.callPhone){
          return false;
        }
        if(this.callPhone.length==1){
          this.callPhone="";
          return false;
        }
        this.callPhone=this.callPhone.substring(0,this.callPhone.length-1);
      },
      callNumber:function(number){
        if(!this.callPhone){
          this.callPhone=number;
        }else {
          this.callPhone=this.callPhone+number;
        }
        this.$emit("closedtmf",number);
      },
      cancel:function(){
        document.onkeydown = undefined;
        this.$emit("closeDialerPage",false);
      },
      call:function () {
        let reg=/[0-9\*\#]/gi;
        if(!reg.test(this.callPhone)){
          this.$Message.info("电话号码格式错误,请重新输入");
          return false;
        }
        document.onkeydown = undefined;
        this.$emit("closeDialerPage",true,this.callPhone);
      }
    },
    watch:{
      showDialer:function () {
        this.model=this.showDialer;
        this.callPhone="";
        this.docTitle="";
        this.showBtn=true;
        let that=this;
        document.onkeydown = undefined;
        if(this.showDialer){
          document.onkeydown = function(){
            let key = window.event.keyCode;
            if(key === 13){
              that.call()
            }
          };
        }
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/loginHeadMange/DialerPage.vue